import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'suspicionDate'
})
export class SuspicionDatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value) { return 'n/a'; };

    const dateValue: Date = new Date(value);
    return dateValue.getFullYear().toString() + '-' +
      ('0' + (dateValue.getMonth() + 1)).slice(-2).toString() + '-' +
      ('0' + dateValue.getDate()).slice(-2).toString();
  }

}



// WEBPACK FOOTER //
// /Users/bdegroot/Projects/vgtropics-ph/src/app/suspicion-date.pipe.ts